import { DeepReactive } from '@jack-henry/frontend-utils/lit';

import { IpRestrictionAddress } from '@treasury/domain/backoffice/services/access/entities/ip-restriction-address.entity';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/jh-ui/tm-button';
import '@treasury/presentation/components/jh-ui/tm-input';
import '@treasury/presentation/components/jh-ui/tm-switch';
import { TmButtonType } from '@treasury/presentation/components/tm-button.types';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './ip-address.component';

@customElement('tm-bo-ip-access')
export class IpAccessComponent extends TmBaseComponent {
    @property({ type: Boolean })
    private restricted: boolean = false;

    @DeepReactive()
    private ipAddresses: IpRestrictionAddress[] = [];

    public render() {
        return html`
            <div>
                <h1 class="text-2xl font-bold mb-6">IP Access</h1>
                <p class="mb-4">Create a list of IP addresses a user can use.</p>
                ${this.renderRestrictedToggle()}
                ${this.ipAddresses?.map((ipRestriction, index) =>
                    this.renderIpRestriction(ipRestriction, index)
                )}
                ${this.restricted
                    ? html`<tm-button
                          importance="tertiary"
                          @click=${this.handleAddIpAddress}
                          .type=${TmButtonType.None}
                      >
                          <div class="flex flex-row items-center gap-2">
                              <jh-icon-plus size="x-small"></jh-icon-plus>
                              <div class="text-[13px] leading-[150%] font-medium">
                                  Add another IP address
                              </div>
                          </div>
                      </tm-button>`
                    : nothing}
            </div>
        `;
    }

    private renderIpRestriction(ipAddress: IpRestrictionAddress, index: number) {
        return html`<tm-bo-ip-address
            .ipAddress=${ipAddress}
            .index=${index}
            .restricted=${this.restricted}
            @delete=${this.handleDeleteIpAddress}
        ></tm-bo-ip-address>`;
    }

    private renderRestrictedToggle() {
        return html`<tm-jh-switch
            class="mb-2"
            .initial=${this.restricted}
            .name=${'ip.restricted'}
            .label=${'Restricted'}
            @change=${this.handleRestrictedToggle}
        >
        </tm-jh-switch>`;
    }

    private handleAddIpAddress() {
        if (!this.ipAddresses) {
            return;
        }
        this.ipAddresses.push(new IpRestrictionAddress());
        this.ipAddresses = new Proxy(this.ipAddresses, {});
        this.requestUpdate();
    }

    private handleDeleteIpAddress(e: CustomEvent<{ entityId: string }>) {
        const { entityId } = e.detail;
        if (!this.ipAddresses) {
            return;
        }
        const newIpAddresses = this.ipAddresses.filter(
            restriction => restriction.entityId !== entityId
        );
        this.ipAddresses = new Proxy(newIpAddresses, {});
        this.requestUpdate();
    }

    private handleRestrictedToggle(e: CustomEvent<boolean>) {
        if (!this.ipAddresses) {
            return;
        }
        this.restricted = e.detail;
    }
}
